import { useEffect, useState, type ReactNode } from "react";

type PanelRole = "alert" | "status" | "region";

export function PanelCloseButton({ onClose, label = "Close panel", className = "" }: { onClose: () => void; label?: string; className?: string }) {
  return (
    <button className={`panel-close-button ${className}`.trim()} type="button" onClick={onClose} aria-label={label}>
      <span aria-hidden="true">×</span>
    </button>
  );
}

export function CloseablePanel({ children, className = "", role = "region", ariaLive = "polite", closeLabel = "Close panel", resetKey = "", onClose }: { children: ReactNode; className?: string; role?: PanelRole; ariaLive?: "polite" | "assertive" | "off"; closeLabel?: string; resetKey?: string; onClose?: () => void }) {
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => setDismissed(false), [resetKey]);

  if (dismissed) return null;

  const dismiss = () => {
    setDismissed(true);
    onClose?.();
  };

  return (
    <div className={`closeable-panel ${className}`.trim()} role={role} aria-live={ariaLive}>
      <div className="panel-content">{children}</div>
      <PanelCloseButton onClose={dismiss} label={closeLabel} />
    </div>
  );
}
